<template>
  <div>
    <template v-for="(child, index) in menuData">
      <el-submenu v-if="child.children.length > 0" :index="child.path">
        <template slot="title">
          <!-- 修复这里：类名直接写字符串 -->
          <i :class="child.iconCls || 'fa fa-file'"></i>
          <span>{{ child.name }}</span>
        </template>
        <menu-tree :menuData="child.children"></menu-tree>
      </el-submenu>

      <el-menu-item v-else-if="!child.hidden" :index="child.path">
        <!-- 修复这里：类名直接写字符串 -->
        <i :class="child.iconCls || 'fa fa-file'"></i>
        <span>{{ child.name }}</span>
      </el-menu-item>
    </template>
  </div>
</template>

<script>
export default {
  name: "menuTree",
  props: ["menuData"],
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/system/index/layout/aside/menuTree.vue